import { Link } from "react-router-dom";

const AIChatHistoryItem = props => {
  const { listItem } = props;
  return (
    <Link
      to={`/ai/chat/${listItem?._id}`}
      className="events-page-aichat-history-content-row-box"
    >
      <div className="events-page-aichat-history-content-row-box-text">
        {listItem?.name}
      </div>
    </Link>
  );
};

export default AIChatHistoryItem;
